import { BasicLayout, UserLayout, BlankLayout } from '@/layouts'

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view')
}

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: 'menu.home' },
    redirect: '/home/page',
    children: [
      // {
      //   path:'/admin',
      //   component:RouteView,
      //   name:'admin',
      //   meta:{title:'管理后台'}
      // }, 
      {
        path: '/account',
        component: RouteView,
        redirect: '/account/settings',
        name: 'account',
        meta: { title: 'menu.account', icon: 'user', keepAlive: true, permission: ['user'], appCode: 'admin' },
        children: [
          // {
          //   path: '/account/center',
          //   name: 'center',
          //   component: () => import('@/views/account/center'),
          //   meta: { title: 'menu.account.center', keepAlive: true, permission: ['user'] }
          // },
          {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: 'menu.account.settings', hideHeader: true, permission: ['user'] },
            redirect: '/account/settings/basic',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/account/settings/basic',
                name: 'BasicSettings',
                component: () => import('@/views/account/settings/BasicSetting'),
                meta: { title: 'account.settings.menuMap.basic', hidden: true, permission: ['user'] }
              },
              {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/account/settings/Security'),
                meta: {
                  title: 'account.settings.menuMap.security',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              },
              // {
              //   path: '/account/settings/custom',
              //   name: 'CustomSettings',
              //   component: () => import('@/views/account/settings/Custom'),
              //   meta: { title: '首页背景', hidden: true, keepAlive: true, permission: ['user'] }
              // },
              // {
              //   path: '/account/settings/large-screen',
              //   name: 'LargeScreenSetting',
              //   component: () => import('@/views/account/settings/LargeScreen'),
              //   meta: { title: '大屏背景', hidden: true, keepAlive: true, permission: ['user'] }
              // },
              {
                path: '/account/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/account/settings/Binding'),
                meta: {
                  title: 'account.settings.menuMap.binding',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              },
              {
                path: '/account/settings/notification',
                name: 'NotificationSettings',
                component: () => import('@/views/account/settings/Notification'),
                meta: {
                  title: 'account.settings.menuMap.notification',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              }
            ]
          }
        ]
      },
      {
        path: '/manager',
        name: 'managerPage',
        component: RouteView,
        meta: { title: '权限管理', icon: 'user', permission: ['dashboard'] },
        redirect: '/other/icon-selector',
        children: [
          {
            path: '/manager/list/tree-list',
            name: 'TreeList',
            component: () => import('@/views/manager/sys/MenuList'),
            meta: { title: '树目录表格', keepAlive: true }
          },
          {
            path: '/manager/list/edit-table',
            name: 'EditList',
            component: () => import('@/views/other/TableInnerEditList'),
            meta: { title: '内联编辑表格', keepAlive: true }
          },
          {
            path: '/manager/list/user-list',
            name: 'UserList',
            component: () => import('@/views/manager/sys/UserList'),
            meta: { title: '用户列表', keepAlive: true }
          },
          {
            path: '/manager/list/role-list',
            name: 'RoleList',
            component: () => import('@/views/manager/sys/RoleList'),
            meta: { title: '角色列表', keepAlive: true }
          },
          // {
          //   path: '/other/list/system-role',
          //   name: 'SystemRole',
          //   component: () => import('@/views/role/RoleList'),
          //   meta: { title: '角色列表2', keepAlive: true }
          // },
          {
            path: '/other/list/permission-list',
            name: 'PermissionList',
            component: () => import('@/views/other/PermissionList'),
            meta: { title: '权限列表', keepAlive: true }
          }
        ]
      },
      // other
      {
        path: '/other',
        name: 'otherPage',
        component: RouteView,
        meta: { title: '其他组件', icon: 'slack', permission: ['dashboard'], appCode: 'admin' },
        redirect: '/other/icon-selector',
        children: [
          {
            path: '/other/icon-selector',
            name: 'TestIconSelect',
            component: () => import('@/views/other/IconSelectorView'),
            meta: { title: 'IconSelector', icon: 'tool', keepAlive: true, permission: ['dashboard'] }
          }
        ]
      },
      {
        path: '/permission',
        name: 'permission',
        component: RouteView,
        meta: {
          title: '权限管理',
          icon: 'lock',
          permission: ['permission'],
          appCode: 'admin'
        },
        redirect: '/manager/tenant/index',
        children: [
          {
            path: '/permission/index',
            name: 'permissionIndex',
            component: () => import('@/views/other/PermissionList'),
            meta: { title: '权限列表', icon: 'tool', keepAlive: true, permission: ['qxgl'] }
          },
          {
            path: '/manager/tenant/index',
            name: 'tenantIndex',
            component: () => import('@/views/manager/sys/TenantList'),
            meta: { title: '水司管理', icon: 'user', keepAlive: true, permission: ['tenant-manager'] }
          },
          {
            path: '/manager/app/listIndex',
            name: 'applistIndex',
            component: () => import('@/views/manager/app/AppListNew'),
            meta: { title: '应用列表', icon: 'appstore', keepAlive: true, permission: ['app-listnew'] }
          },
          {
            path: '/manager/dept/index',
            name: 'DeptList',
            component: () => import('@/views/manager/sys/DeptList'),
            meta: { title: '部门管理', icon: 'usergroup-add', keepAlive: true, permission: ['dept-manager'] }
          },
          {
            path: '/map/index',
            name: 'myMap',
            component: () => import('@/views/map'),
            meta: { title: '我的地图', icon: 'user-add', keepAlive: true, permission: ['my-map'] }
          },
          {
            path: '/manager/user/index',
            name: 'UserList',
            component: () => import('@/views/manager/sys/UserList'),
            meta: { title: '用户管理', icon: 'user-add', keepAlive: true, permission: ['user-manager'] }
          },
          {
            path: '/manager/role/index',
            name: 'roleIndex',
            component: () => import('@/views/manager/sys/RoleList'),
            meta: { title: '角色管理', icon: 'user', keepAlive: true, permission: ['role-manager'] }
          },
          {
            path: '/manager/menu/index',
            name: 'menuIndex',
            component: () => import('@/views/manager/sys/MenuList'),
            meta: { title: '菜单管理', icon: 'menu', keepAlive: true, permission: ['menu-manager'] }
          },
          {
            path: '/manager/icon/index',
            name: 'menuIndex',
            component: () => import('@/views/other/IconSelectorView'),
            meta: { title: '图标管理', icon: 'tool', keepAlive: true, permission: ['icon-manager'] }
          }
        ]
      },
      {
        path: '/app',
        name: 'app',
        component: RouteView,
        meta: {
          title: '应用管理',
          icon: 'appstore',
          permission: ['app-manager'],
          appCode: 'admin'
        },
        redirect: '/manager/app/index',
        children: [
          {
            path: '/manager/app/index',
            name: 'appIndex',
            component: () => import('@/views/manager/app/AppList'),
            meta: { title: '应用列表', icon: 'appstore', keepAlive: true, permission: ['app-list'] }
          },
          {
            path: '/manager/app/tenant/index',
            name: 'tenantAppIndex',
            component: () => import('@/views/manager/app/TenantApp'),
            meta: { title: '水司应用', icon: 'appstore', keepAlive: true, permission: ['tenant-app'] }
          },
          {
            path: '/manager/app/appVersion',
            name: 'AppVersion',
            component: () => import('@/views/manager/app/AppMobileTabs'),
            meta: { title: 'APK管理', icon: 'android', keepAlive: true, permission: ['app-version'] }
          }
        ]
      },
      {
        path: '/setting',
        name: 'setting',
        component: RouteView,
        meta: {
          title: '系统设置',
          icon: 'setting',
          permission: ['system-config'],
          appCode: 'admin'
        },
        redirect: '/manager/config/index',
        children: [
          {
            path: '/manager/config/index',
            name: 'configIndex',
            component: () => import('@/views/manager/setting/ConfigList'),
            meta: { title: '系统配置', icon: 'tool', keepAlive: true, permission: ['config-manager'] }
          },
          {
            path: '/manager/TenantConfig/index',
            name: 'TenantConfigIndex',
            component: () => import('@/views/manager/setting/TenantConfigList'),
            meta: { title: '水司配置', icon: 'tool', keepAlive: true, permission: ['tenant-config'] }
          },
          {
            path: '/manager/dict/index',
            name: 'dictIndex',
            component: () => import('@/views/manager/setting/DictList'),
            meta: { title: '字典管理', icon: 'database', keepAlive: true, permission: ['dict-manager'] }
          },
          {
            path: '/manager/bulletin/board',
            name: 'BulletinBoardIndex',
            component: () => import('@/views/manager/setting/BulletinBoard'),
            meta: { title: '公告管理', icon: 'notification', keepAlive: true, permission: ['bulletinBoard-manager'] }
          },
          {
            path: '/manager/waterQuality/index',
            name: 'WaterQualityIndex',
            component: () => import('@/views/manager/setting/WaterQuality'),
            meta: { title: '水质监测', icon: 'notification', keepAlive: true, permission: ['waterQuality-manager'] }
          },
          {
            path: '/manager/MaintenanceIndicators/index',
            name: 'MaintenanceIndicators',
            component: () => import('@/views/manager/setting/MaintenanceIndicators'),
            meta: {
              title: '维修指标',
              icon: 'notification',
              keepAlive: true,
              permission: ['MaintenanceIndicators-manager']
            }
          },
          {
            path: '/manager/tagerSetting/index',
            name: 'TagerSetting',
            component: () => import('@/views/manager/setting/TagerSetting'),
            meta: { title: '指标、营收设置', icon: 'notification', keepAlive: true, permission: ['taget-setting'] }
          },
          {
            path: '/manager/remoteSetting/index',
            name: 'RemoteSetting',
            component: () => import('@/views/manager/setting/RemoteSetting'),
            meta: { title: '远传表工作台设置', icon: 'notification', keepAlive: true, permission: ['remote-setting'] }
          },
          {
            path: '/manager/point-location/index',
            name: 'PointLocation',
            component: () => import('@/views/manager/setting/point-location'),
            meta: { title: '水厂到水源点位', icon: 'notification', keepAlive: true, permission: ['point-location'] }
          },
          {
            path: '/manager/monthly-indicators/index',
            name: 'MonthlyIndicators',
            component: () => import('@/views/manager/setting/monthly-indicators'),
            meta: { title: '水厂月度指标', icon: 'notification', keepAlive: true, permission: ['monthly-indicators'] }
          },
          {
            path: '/manager/materials-handling/index',
            name: 'Materialsandling',
            component: () => import('@/views/manager/setting/materials-handling'),
            meta: { title: '材料管理', icon: 'notification', keepAlive: true, permission: ['materials-handling'] }
          },
          {
            path: '/manager/LargeScreenDisplay/index',
            name: 'LargeScreenDisplay',
            component: () => import('@/views/manager/setting/LargeScreenDisplay'),
            meta: { title: '大屏配置', icon: 'notification', keepAlive: true, permission: ['large-screen-display'] }
          },
          // {
          //   path: '/manager/DataAdministration/index',
          //   name: 'DataAdministration',
          //   component: () => import('@/views/manager/setting/DataAdministration'),
          //   meta: { title: '大用户数据管理', icon: 'notification', keepAlive: true, permission: ['data-administration'] }
          // },
          {
            path: '/manager/backgroundSettings/index',
            name: 'backgroundSettings',
            component: () => import('@/views/account/settings/background-setting'),
            meta: { title: '背景管理', icon: 'notification', hideHeader: true, permission: ['backgroundSettings'] },
            redirect: '/account/settings/large-screen',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/account/settings/large-screen',
                name: 'LargeScreenSetting',
                component: () => import('@/views/account/settings/LargeScreen'),
                meta: { title: '大屏背景', hidden: true, keepAlive: true, permission: ['user'] }
              },
              {
                path: '/account/settings/custom',
                name: 'CustomSettings',
                component: () => import('@/views/account/settings/Custom'),
                meta: { title: '首页背景', hidden: true, keepAlive: true, permission: ['user'] }
              }
            ]
          }
        ]
      },
      {
        path: '/partition-map-real',
        redirect: '/partition-one-map',
        name: 'partitionMapReal',
        meta: {
          title: '分区计量全览图',
          keepAlive: false,
          target: '_blank',
          appCode: 'zone_metering',
          icon: 'environment',
          permission: ['partition-one-map']
        }
      },
      {
        path: '/partition/workbench',
        name: 'partitionWorkbench',
        meta: {
          title: '工作台',
          icon: 'dashboard',
          permission: ['partition'],
          appCode: 'zone_metering',
          target: '_blank'
        },
        component: () => import('@/views/partition/workbench/workbench')
      },
      {
        path: '/partition',
        name: 'partition',
        component: RouteView,
        meta: {
          title: '分区管理',
          icon: 'hdd',
          permission: ['partition'],
          appCode: 'zone_metering'
        },
        redirect: '/partition/management',
        children: [
          {
            path: '/partition/management',
            name: 'PartitionManagement',
            component: () => import('@/views/partition/management/management'),
            meta: { title: '分区管理', icon: 'solution', keepAlive: true, permission: ['partition-management'] }
          },
          {
            path: '/partition/water-plant-area',
            name: 'WaterPlantArea',
            component: () => import('@/views/partition/management/WaterPlantArea'),
            meta: { title: '水厂范围', icon: 'tool', keepAlive: true, permission: ['water-plant-area'] }
          },
          {
            path: '/remote-water-meter',
            name: 'remote-water-meter',
            component: RouteView,
            meta: { title: '片区关联点', icon: 'tool', keepAlive: true, permission: ['water-associated-points'] },
            children: [
              {
                path: '/partition/remote-water-meter',
                name: 'partitionRemoteWaterMeter',
                component: () => import('@/views/partition/management/RemoteWaterMeter'),
                meta: {
                  title: '分区计量仪表',
                  icon: 'tool',
                  keepAlive: true,
                  permission: ['partition-remote-water-meter']
                }
              },
              {
                path: '/partition/associated_points',
                name: 'associatedPoints',
                component: () => import('@/views/pipenetwork/waterMeter/ZoneAssociatedPoint'),
                meta: { title: '分界阀门', icon: 'tool', keepAlive: true, permission: ['water-associated-points'] }
              }
            ]
          },
          {
            path: '/partition/rules',
            name: 'PartitionRules',
            component: () => import('@/views/partition/rules/rules'),
            meta: { title: '分区计量规则', icon: 'solution', keepAlive: true, permission: ['partition-rules'] }
          },
          {
            path: '/partition/differentRules',
            name: 'PartitionDifferentRules',
            component: () => import('@/views/partition/differentRules/differentRules'),
            meta: {
              title: '分区参考值配置',
              icon: 'solution',
              keepAlive: true,
              permission: ['partition-differentRules']
            }
          }
        ]
      },
      {
        path: '/partition/user',
        name: 'partitionUser',
        component: RouteView,
        meta: {
          title: '用户管理',
          icon: 'user',
          permission: ['partition-user'],
          appCode: 'zone_metering'
        },
        redirect: '/partition/user/parallelLargeUser',
        children: [
          {
            path: '/partition/user/ParallelLargeUser',
            name: 'parallelLargeUser',
            component: () => import('@/views/partition/user/ParallelLargeUser'),
            meta: { title: '平行大用户', icon: 'tool', keepAlive: true, permission: ['parallel_large_user'] }
          }
        ]
      },
      {
        path: '/partition/sAnalysis',
        name: 'partitionSAnalysis',
        component: RouteView,
        meta: {
          title: '统计分析',
          icon: 'user',
          permission: ['partition-sAnalysis'],
          appCode: 'zone_metering'
        },
        redirect: '/partition/nighttimeMinStatistics',
        children: [
          {
            path: '/partition/nighttimeMinStatistics',
            name: 'nighttimeMinStatistics',
            component: () => import('@/views/partition/nighttimeMinStatistics'),
            meta: {
              title: '夜间最小流量分析统计',
              icon: 'solution',
              keepAlive: true,
              permission: ['partition-differentRules']
            }
          },
          {
            path: '/partition/sAnalysis/AreaTrafficAnalysis',
            name: 'areaTrafficAnalysis',
            component: () => import('@/views/partition/sAnalysis/AreaTrafficAnalysis'),
            meta: { title: '片区流量统计', icon: 'solution', keepAlive: true, permission: ['area_traffic_analysis'] }
          },
          {
            path: '/leakage',
            name: 'leakage',
            component: RouteView,
            meta: {
              title: '漏损管理',
              icon: 'container',
              permission: ['leakage'],
              appCode: 'zone_metering'
            },
            redirect: '/leakage/analysis',
            children: [
              {
                path: '/LeakageRate/ALeakageAnalysis',
                name: 'ALeakageAnalysis',
                component: () => import('@/views/partition/leakage/ALeakageAnalysis'),
                meta: {
                  title: '漏损自动统计分析',
                  icon: 'solution',
                  keepAlive: true,
                  permission: ['automatically-leakage-analysis']
                }
              },
              {
                path: '/LeakageRate/management',
                name: 'LeakageRate',
                component: () => import('@/views/partition/leakage/LeakageRate'),
                meta: { title: '漏损率计算', icon: 'solution', keepAlive: true, permission: ['Leakage-rate'] }
              },
              {
                path: '/leakage/analysis',
                name: 'leakageAnalysis',
                component: () => import('@/views/partition/leakage/analysis'),
                meta: { title: '统计分析', icon: 'solution', keepAlive: true, permission: ['leakage-analysis'] }
              }
            ]
          },
          {
            path: '/WaterBalance',
            name: 'WaterBalance',
            component: RouteView,
            meta: {
              title: '水平衡管理',
              icon: 'container',
              permission: ['WaterBalance'],
              appCode: 'zone_metering'
            },
            redirect: '/WaterBalance/management',
            children: [
              {
                path: '/WaterBalance/management',
                name: 'WaterBalance',
                component: () => import('@/views/partition/leakage/WaterBalance'),
                meta: { title: '水平衡计算', icon: 'tool', keepAlive: true, permission: ['water-balance'] }
              },
              {
                path: '/WaterBalance/analysis',
                name: 'WaterAnalysis',
                component: () => import('@/views/partition/leakage/WaterAnalysis'),
                meta: { title: '水平衡分析', icon: 'solution', keepAlive: true, permission: ['water-analysis'] }
              },
              {
                path: '/WaterBalance/MWaterAnalysis',
                name: 'MWaterAnalysis',
                component: () => import('@/views/partition/leakage/MWaterAnalysis'),
                meta: { title: '水平衡月分析', icon: 'solution', keepAlive: true, permission: ['month-water-analysis'] }
              }
            ]
          }
        ]
      },

      {
        path: '/zone-alarm-management',
        name: 'ZoneAlarmManagement',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['zone_metering'],
          appCode: 'zone_metering'
        },
        redirect: '/zone-alarm-management/zone-alarm-list',
        children: [
          {
            path: '/zone-alarm-management/dual-track-warning',
            name: 'DualTrackWarning',
            component: () => import('@/views/zone-alarm-management/dual-track-warning'),
            meta: { title: '双轨预警算法beta', icon: 'line-chart', keepAlive: true, permission: ['zone-alarm-list'] }
          },
          {
            path: '/zone-alarm-set',
            name: 'zone-alarm-set',
            component: RouteView,
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['zone-alarm-set'] },
            children: [
              {
                path: '/zone-alarm-management/zone-alarm-set',
                name: 'ZoneAlarmSet',
                component: () => import('@/views/zone-alarm-management/zone-alarm-set'),
                meta: { title: '夜间流量报警设置', icon: 'tool', keepAlive: true, permission: ['zone-alarm-set'] }
              },
              {
                path: '/zone-alarm-management/zone-interrupt-set',
                name: 'zone-interrupt-set',
                component: () => import('@/views/zone-alarm-management/zone-interrupt-set'),
                meta: { title: '数据上传中断报警设置', icon: 'tool', keepAlive: true, permission: ['zone-alarm-set'] }
              }
            ]
          },

          {
            path: '/zone-alarm-list',
            name: 'zone-alarm-list',
            component: RouteView,
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['zone-alarm-list'] },
            children: [
              {
                path: '/zone-alarm-management/zone-alarm-list',
                name: 'ZoneAlarmList',
                component: () => import('@/views/zone-alarm-management/zone-alarm-list'),
                meta: { title: '夜间流量报警列表', icon: 'tool', keepAlive: true, permission: ['zone-alarm-list'] }
              },
              {
                path: '/zone-alarm-management/zone-interrupt-list',
                name: 'zoneinterruptlist',
                component: () => import('@/views/zone-alarm-management/zone-interrupt-list'),
                meta: { title: '数据上传中断报警列表', icon: 'tool', keepAlive: true, permission: ['zone-alarm-list'] }
              }
            ]
          }

          // {
          //   path: '/zone-alarm-management/zone-alarm-list',
          //   name: 'ZoneAlarmList',
          //   component: () => import('@/views/zone-alarm-management/zone-alarm-list'),
          //   meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['zone-alarm-list'] },
          // },
          // {
          //   path: '/zone-alarm-management/zone-alarm-set',
          //   name: 'ZoneAlarmSet',
          //   component: () => import('@/views/zone-alarm-management/zone-alarm-set'),
          //   meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['zone-alarm-set'] },
          // },
        ]
      },
      {
        path: '/partition/historical',
        name: 'partitionHistorical',
        component: RouteView,
        meta: {
          title: '历史数据',
          icon: 'tool',
          permission: ['partition-historical'],
          appCode: 'zone_metering'
        },
        redirect: '/partition/user/parallelLargeUser',
        children: [
          {
            path: '/partition/water-meter-history',
            name: 'partitionRemoteWaterMeterHistory',
            component: () => import('@/views/partition/management/WaterMeterHistory'),
            meta: {
              title: '分区计量仪表历史数据',
              icon: 'tool',
              keepAlive: true,
              permission: ['partition-water-meter-history']
            }
          }
        ]
      },
      {
        path: '/partition/expand',
        name: 'partitionExpand',
        meta: {
          title: '片区维修记录',
          icon: 'dashboard',
          permission: ['partition-expand'],
          appCode: 'zone_metering'
        },
        component: () => import('@/views/partition/expand/Maintain')
      },
      //gis
      {
        path: '/pipe-network/workbench',
        name: 'pipeNetworkWorkbench',
        meta: {
          title: '工作台',
          icon: 'dashboard',
          permission: ['pipe-network-gis'],
          appCode: 'pipe_network',
          target: '_blank'
        },
        component: () => import('@/views/pipenetwork/workBench/index')
      },
      // {
      //   path: '/one-map-real',
      //   redirect: '/one-map',
      //   name: 'oneMapReal',
      //   meta: {
      //     title: 'GIS管网全览图',
      //     keepAlive: false,
      //     target: '_blank',
      //     appCode: 'pipe_network',
      //     icon: 'environment',
      //     permission: ['one-map']
      //   }
      // },
      {
        path: '/new-one-map-real',
        redirect: '/new-one-map',
        name: 'newOneMapReal',
        meta: {
          title: 'GIS管网全览图',
          keepAlive: false,
          target: '_blank',
          appCode: 'pipe_network',
          icon: 'environment',
          permission: ['one-map']
        }
      },
      {
        path: '/pipe-network',
        name: 'pipeNetwork',
        component: RouteView,
        meta: {
          title: '物探点线数据',
          icon: 'setting',
          permission: ['pipe-network-gis'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/gis-pipe-network/index',
        children: [
          {
            path: '/pipe-network/gis-pipe-network/index',
            name: 'gisPipeNetworkData',
            component: () => import('@/views/pipenetwork/GisPipeNetworkList'),
            meta: { title: '物探点数据', icon: 'tool', keepAlive: true, permission: ['pipe-network-data'] }
          },
          {
            path: '/pipe-network/gis-pipe-line/index',
            name: 'GisPipeLineLayer',
            component: () => import('@/views/pipenetwork/GisPipeLineLayer'),
            meta: { title: '管线数据', icon: 'tool', keepAlive: true, permission: ['pipe-line-layer'] }
          },
          {
            path: '/Water-outage-control/Wateroutage-control/GisPipeNetworkRule',
            name: 'GisPipeNetworkRule',
            component: () => import('@/views/Water-outage-control/Wateroutage-control/GisPipeNetworkRule'),
            meta: { title: '物探点规则', icon: 'setting', keepAlive: true, permission: ['pipe-network-rule'] }
          }
        ]
      },
      {
        path: '/pipe-network/waterMeter',
        name: 'waterMeter',
        component: RouteView,
        meta: {
          title: '水表管理',
          icon: 'setting',
          permission: ['pipe-network-water-meters'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/data/index',
        children: [
          {
            path: '/pipe-network/gis-class-user-water-meter',
            name: 'gisClassUserWaterMeter',
            component: () => import('@/views/pipenetwork/waterMeter/GisClassUserWaterMeter'),
            meta: { title: '终端用户水表', icon: 'tool', keepAlive: true, permission: ['user-water-meter'] }
          }
        ]
      },
      {
        path: '/pipe-network/check-pipe',
        name: 'check-pipe',
        component: RouteView,
        meta: {
          title: '数据检查',
          icon: 'setting',
          permission: ['check-pipe'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/data/index',
        children: [
          {
            path: '/pipe-network/point-check',
            name: 'pointCheck',
            component: () => import('@/views/pipenetwork/PointCheck'),
            meta: { title: '物探点数据检查', icon: 'tool', keepAlive: true, permission: ['point-check'] }
          },
          {
            path: '/pipe-network/line-check',
            name: 'lineCheck',
            component: () => import('@/views/pipenetwork/LineCheck'),
            meta: { title: '管线数据检查', icon: 'tool', keepAlive: true, permission: ['line-check'] }
          }
        ]
      },
      // {
      //   path: '/pipe-network/task',
      //   name: 'task',
      //   component: RouteView,
      //   meta: {
      //     title: '任务管理',
      //     icon: 'setting',
      //     permission: ['task'],
      //     appCode: 'pipe_network',
      //   },
      //   redirect: '/pipe-network/data/index',
      //   children: [
      //     {
      //       path: '/pipe-network/task-management',
      //       name: 'taskManagement',
      //       component: () => import('@/views/pipenetwork/TaskManagement'),
      //       meta: { title: '任务管理信息', icon: 'tool', keepAlive: true, permission: ['task-management'] },
      //     },
      //   ],
      // },
      {
        path: '/pipe-network/coordinate',
        name: 'coordinate',
        component: RouteView,
        meta: {
          title: '坐标信息',
          icon: 'setting',
          permission: ['coordinate'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/data/index',
        children: [
          {
            path: '/pipe-network/coordinate/coordinate-convert',
            name: 'coordinateConvert',
            component: () => import('@/views/pipenetwork/coordinate/CoordinateConvert'),
            meta: { title: '坐标转换', icon: 'tool', keepAlive: true, permission: ['coordinate-convert'] }
          }
        ]
      },
      {
        path: '/pipe-network/settings',
        name: 'settings',
        component: RouteView,
        meta: {
          title: '基础配置',
          icon: 'setting',
          permission: ['settings'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/data/index',
        children: [
          {
            path: '/pipe-network/coordinate/element-setting',
            name: 'elementSetting',
            component: () => import('@/views/pipenetwork/settings/elementSetting'),
            meta: { title: '分类编码设置', icon: 'tool', keepAlive: true, permission: ['element-setting'] }
          }
        ]
      },
      {
        path: '/pipe-network/zone-data',
        name: 'gis-partition-management',
        component: RouteView,
        meta: {
          title: '分区管理',
          icon: 'setting',
          permission: ['gis-partition-management'],
          appCode: 'pipe_network'
        },
        redirect: '/pipe-network/data/index',
        children: [
          {
            path: '/partition/zone-data',
            name: 'PartitionManagementZoneData',
            component: () => import('@/views/pipenetwork/ZoneManagement'),
            meta: { title: '分区管理', icon: 'solution', keepAlive: true, permission: ['gis-partition-management'] }
          }
        ]
      },
      {
        path: '/sys/legend',
        name: 'LegendManager',
        component: RouteView,
        meta: {
          title: '图例图层',
          icon: 'setting',
          permission: ['sys-legend-manager'],
          appCode: 'admin'
        },
        redirect: '/sys/layer/index',
        children: [
          {
            path: '/sys/layer/layer',
            name: 'LayerIndex',
            component: () => import('@/views/manager/legend/layer'),
            meta: { title: '图层管理', icon: 'fund', keepAlive: true, permission: ['layer-manager'] }
          },
          {
            path: '/sys/legend/index',
            name: 'LegendIndex',
            component: () => import('@/views/manager/legend/legend'),
            meta: { title: '图例管理', icon: 'heat-map', keepAlive: true, permission: ['legend-manager'] }
          },
          {
            path: '/sys/style/index',
            name: 'styleIndex',
            component: () => import('@/views/manager/legend/style'),
            meta: { title: '样式管理', icon: 'folder-open', keepAlive: true, permission: ['legend-style'] }
          },
          {
            path: '/sys/gis-legend/index',
            name: 'GisLegendIndex',
            component: () => import('@/views/manager/legend/gisLegend'),
            meta: { title: 'GIS编辑图例', icon: 'project', keepAlive: true, permission: ['gis-legend-manager'] }
          }
        ]
      },
      {
        path: '/file',
        name: 'file',
        component: RouteView,
        meta: {
          title: '文件管理',
          icon: 'file',
          permission: ['file-manager'],
          appCode: 'admin'
        },
        redirect: '/file/index',
        children: [
          {
            path: '/file/index',
            name: 'FileList',
            component: () => import('@/views/manager/file/FileList'),
            meta: { title: '文件列表', icon: 'tool', keepAlive: true, permission: ['file-list'] }
          }
        ]
      },
      {
        path: '/sys-client',
        name: 'sys-client',
        component: RouteView,
        meta: {
          title: '客户端管理',
          icon: 'file',
          permission: ['sys-client'],
          appCode: 'admin'
        },
        redirect: '/sys-client/index',
        children: [
          {
            path: '/sys-client/index',
            name: 'SysClientApiKeyList',
            component: () => import('@/views/pipenetwork/waterMeter/SysClientApiKey'),
            meta: { title: '客户端API_KEY', icon: 'tool', keepAlive: true, permission: ['sys-client-api-keys'] }
          }
        ]
      },
      {
        path: '/log',
        name: 'log',
        component: RouteView,
        meta: {
          title: '日志管理',
          icon: 'setting',
          permission: ['sys-log-manager'],
          appCode: 'admin'
        },
        redirect: '/manager/log/operation',
        children: [
          {
            path: '/manager/log/operation',
            name: 'loginLog',
            component: () => import('@/views/manager/log/LogList'),
            meta: { title: '操作日志', icon: 'tool', keepAlive: true, permission: ['operation-log'] }
          }
        ]
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/manager/feedback/feedbackList'),
        meta: {
          title: '反馈管理',
          icon: 'setting',
          permission: ['sys-log-manager'],
          appCode: 'admin'
        }
      },
      {
        path: '/notemanage',
        name: 'notemanage',
        component: RouteView,
        meta: {
          title: '短信管理',
          icon: 'setting',
          permission: ['SMSManagement'],
          appCode: 'admin'
        },
        redirect: '/notemanage/aliyun-sms-config',
        children: [
          {
            path: '/notemanage/aliyun-sms-config',
            name: 'aliyunSmsConfig',
            component: () => import('@/views/manager/aliyunSms/AliyunSmsConfig'),
            meta: {
              title: '阿里云短信配置',
              icon: 'tool',
              keepAlive: true,
              permission: ['alySMSManagement'],
              appCode: 'admin'
            }
          }
        ]
      },
      {
        path: '/wx-push-manage',
        name: 'wx-push-manage',
        component: RouteView,
        meta: {
          title: '微信推送管理',
          icon: 'setting',
          permission: ['WeChatPushManagement'],
          appCode: 'admin'
        },
        redirect: '/wx-push-manage/notice',
        children: [
          {
            path: '/notemanage/service-config',
            name: 'serviceConfig',
            component: () => import('@/views/notemanage/service-config/index'),
            meta: {
              title: '微信服务号',
              icon: 'tool',
              keepAlive: true,
              permission: ['WeChatServiceAccount'],
              appCode: 'admin'
            }
          },
          {
            path: '/wx-push-manage/notice',
            name: 'wxPushNotice',
            component: () => import('@/views/notemanage/wx-push-notice/index'),
            meta: {
              title: '推送通知页面',
              icon: 'tool',
              keepAlive: true,
              // hiddenTenants: ['default-super-tenant2'],
              permission: ['PushNotificationPage'],
              appCode: 'admin'
            }
          },
          {
            path: '/wx-push-manage/template-manage',
            name: 'wxTemplateManage',
            component: () => import('@/views/notemanage/wx-template-manage/index.vue'),
            meta: {
              title: '消息模板管理',
              icon: 'tool',
              keepAlive: true,
              // onlyTenants: ['default-super-tenant2'],
              permission: ['MessageTemplateManagement'],
              appCode: 'admin'
            }
          }
        ]
      },
      {
        path: '/sys-update',
        name: 'sys-update',
        component: RouteView,
        meta: {
          title: '系统更新',
          icon: 'setting',
          permission: ['app-version'],
          appCode: 'admin'
        },
        redirect: '/sys-update/list',
        children: [
          {
            path: '/sys-update/list',
            name: 'sys-update-list',
            component: () => import('@/views/manager/sysUpdate/SysUpdateList'),
            meta: {
              title: '系统更新',
              permission: ['app-version'],
              appCode: 'admin'
            }
          },
          {
            path: '/sys-update/log',
            name: 'sys-update-log',
            component: () => import('@/views/manager/sysUpdate/SysUpdateLogList'),
            meta: {
              title: '系统版本更新日志',
              permission: ['app-version'],
              appCode: 'admin'
            }
          }
        ]
      },
      // 远程表
      {
        path: '/remote-water/index',
        name: 'RemoteWaterDashboard',
        meta: {
          title: '首页',
          icon: 'home',
          permission: ['remote-water-manager'],
          appCode: 'remote_water'
        },
        component: () => import('@/views/remoteWater/workbench/Index')
      },
      {
        path: '/remote-water',
        name: 'UserRemoteWater',
        component: RouteView,
        meta: {
          title: '表具管理',
          icon: 'setting',
          permission: ['remote-water-manager'],
          appCode: 'remote_water'
        },
        redirect: '/remote-water/user/water',
        children: [
          {
            path: '/remote-water/user/water',
            name: 'userRemoteWaterMeters',
            component: () => import('@/views/remoteWater/UserRemoteWaterList'),
            meta: { title: '贸易结算表', icon: 'tool', keepAlive: true, permission: ['remote-user-water-meter'] }
          },
          {
            path: '/Intelligent-water-plant/error-alarm/malfunction',
            name: 'zoneMeteringRemoteWaterMeters',
            component: () => import('@/views/remoteWater/ZoneMeteringRemoteWaterMeter'),
            meta: { title: '考核流量计', icon: 'tool', keepAlive: true, permission: ['remote-check-flowmeter'] }
          }
        ]
      },
      {
        path: '/remote-water/watch-maintenance',
        name: 'WatchMaintenance',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['remote-watch-maintenance'],
          appCode: 'remote_water'
        },
        children: [
          {
            path: '/remote-water/user/alarm-data',
            name: 'RemoteAlarmData',
            component: () => import('@/views/remoteWater/UserRemoteAlarmData'),
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['remote-user-alarm-data'] }
          },
          {
            path: '/remote-water/user/threshold-data',
            name: 'RemoteThresholdData',
            component: () => import('@/views/remoteWater/RemoteThresholdData'),
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['remote-threshold-data'] }
          }
        ]
      },
      {
        path: '/remote-water/data-history',
        name: 'UserRemoteWaterDataHistory',
        component: RouteView,
        meta: {
          title: '数据报表',
          icon: 'setting',
          permission: ['remote-water-manager'],
          appCode: 'remote_water'
        },
        redirect: '/remote-water/user/water',
        children: [
          // {
          //   path: '/remote-water/data-report',
          //   name: 'userRemoteWaterDataReport',
          //   component: () => import('@/views/remoteWater/UserDataReport'),
          //   meta: { title: '数据报表', icon: 'tool', keepAlive: true, permission: ['remote-user-water-meter'] }
          // },
          {
            path: '/remote-water/user-water/data-history',
            name: 'userRemoteWaterDataHistory',
            component: () => import('@/views/remoteWater/UserDataHistory'),
            meta: {
              title: '贸易结算表历史数据',
              icon: 'tool',
              keepAlive: true,
              permission: ['remote-user-water-meter']
            }
          },
          {
            path: '/remote-water/check-flowmeter/data-history',
            name: 'zoneMeteringRemoteWaterDataHistory',
            component: () => import('@/views/remoteWater/ZoneWaterMeterHistory'),
            meta: {
              title: '考核流量计历史数据',
              icon: 'tool',
              keepAlive: true,
              permission: ['remote-check-flowmeter']
            }
          },
          {
            path: '/remote-water/water-quantity/statement',
            name: 'waterQuantityStatement',
            component: () => import('@/views/remoteWater/WaterStatement'),
            meta: { title: '水量报表', icon: 'tool', keepAlive: true, permission: ['remote-check-flowmeter'] }
          }
        ]
      },
      {
        path: '/remote-water/water-Fluctuation',
        name: 'WaterFluctuation_1',
        component: RouteView,
        meta: {
          title: '水量波动列表',
          icon: 'setting',
          permission: ['remote-water-fluctuation'],
          appCode: 'remote_water'
        },
        redirect: '/remote-water/water-Fluctuation/user',
        children: [
          {
            path: '/remote-water/water-Fluctuation/user',
            name: 'WaterFluctuation',
            component: () => import('@/views/remoteWater/WaterFluctuation'),
            meta: { title: '水量波动列表', icon: 'tool', keepAlive: true, permission: ['remote-water-fluctuation'] }
          }
        ]
      },

      // 新大用户管理系统配置
      {
        path: '/big-users/largeScreen',
        redirect: '/big-user-home',
        name: 'Home',
        meta: {
          title: '大屏展示',
          keepAlive: false,
          target: '_blank',
          appCode: 'big-user-home',
          icon: 'environment',
          permission: ['big-user-screen']
        }
      }, //大用户大屏
      {
        path: '/big-users/workbench/userControl',
        name: 'userControl',
        meta: {
          title: '用户管理',
          icon: 'setting',
          appCode: 'big-user-home',
          permission: ['big-users-control']
        },
        component: RouteView,
        children: [
          {
            path: '/bigusers/workbench/userControl/AllUserPage',
            name: 'AllUserPage',
            component: () => import('@/views/bigusers/workbench/userControl/AllUserPage.vue'),
            meta: { title: '总用户列表', icon: 'tool', keepAlive: true, permission: ['user-control-all-user'] }
          },
          {
            path: '/bigusers/workbench/userControl/BigUserPage',
            name: 'BigUserPage',
            component: () => import('@/views/bigusers/workbench/userControl/BigUserPage.vue'),
            meta: { title: '大用户列表', icon: 'tool', keepAlive: true, permission: ['user-control-big-user'] }
          },
          {
            path: '/bigusers/workbench/userControl/BigUserRulesPage',
            name: 'BigUserRulesPage',
            component: () => import('@/views/bigusers/workbench/userControl/BigUserRulesPage.vue'),
            meta: { title: '大用户规则', icon: 'tool', keepAlive: true, permission: ['user-control-big-user-rules'] }
          }
        ]
      }, //大用户 - 用户管理
      {
        path: '/big-users/workbench/userAlarm',
        name: 'userAlarm',
        component: () => import('@/views/bigusers/workbench/userAlarm/BigUserAlarmPage.vue'),
        meta: {
          title: '大用户报警管理',
          icon: 'setting',
          appCode: 'big-user-home',
          permission: ['big-users-alarm']
        }
      }, //大用户 - 大用户报警管理
      {
        path: '/big-users/workbench/userData',
        name: 'userData',
        meta: {
          title: '大用户历史数据',
          icon: 'setting',
          appCode: 'big-user-home',
          permission: ['big-users-data']
        },
        component: RouteView,
        children: [
          {
            path: '/bigusers/workbench/userData/WaterMeterHistoricalData',
            name: 'WaterMeterHistoricalData',
            component: () => import('@/views/bigusers/workbench/userData/WaterMeterHistoricalData.vue'),
            meta: { title: '水表历史数据', icon: 'tool', keepAlive: true, permission: ['user-data-water-meter'] }
          },
          {
            path: '/bigusers/workbench/userData/FactoryHistoricalData',
            name: 'FactoryHistoricalData',
            component: () => import('@/views/bigusers/workbench/userData/FactoryHistoricalData.vue'),
            meta: { title: '实时推送历史数据', icon: 'tool', keepAlive: true, permission: ['user-control-factory'] }
          }
        ]
      }, //大用户 - 大用户历史数据
      {
        path: '/big-users/workbench/userAnalysis',
        name: 'userAnalysis',
        meta: {
          title: '大用户数据分析',
          icon: 'setting',
          appCode: 'big-user-home',
          permission: ['big-users-analysis']
        },
        component: RouteView,
        children: [
          {
            path: '/bigusers/workbench/userAnalysis/WaterUseAnalysisPage',
            name: 'WaterUseAnalysisPage',
            component: () => import('@/views/bigusers/workbench/userAnalysis/WaterUseAnalysisPage.vue'),
            meta: { title: '用水分析', icon: 'tool', keepAlive: true, permission: ['user-analysis-water'] }
          },
          {
            path: '/bigusers/workbench/userAnalysis/ZoneAnalysisPage',
            name: 'ZoneAnalysisPage',
            component: () => import('@/views/bigusers/workbench/userAnalysis/ZoneAnalysisPage.vue'),
            meta: { title: '片区分析', icon: 'tool', keepAlive: true, permission: ['user-analysis-zone'] }
          }
        ]
      }, //大用户 - 大用户数据分析

      // 智慧水厂系统 water-works-wisdom
      {
        path: '/water-works/homepage',
        redirect: '/water-works-home',
        name: 'WaterPlantLargeScreen',
        meta: {
          title: '智慧水厂',
          keepAlive: false,
          target: '_blank',
          appCode: 'water-works-wisdom',
          icon: 'desktop',
          permission: ['water-works-wisdom']
        }
      },
      {
        // 智慧水厂 - 数据监测
        path: '/water-works/workbench/dataMonitoring',
        name: 'DataMonitoring',
        component: () => import('@/views/waterWorks/workbench/dataMonitoring/DataMonitoring.vue'),
        meta: {
          title: '数据监测',
          icon: 'line-chart',
          appCode: 'water-works-wisdom',
          permission: ['water-works-data-monitoring']
        }
      },
      {
        // 智慧水厂 - 设备管理
        path: '/water-works/workbench/deviceMgmt',
        name: 'DeviceMgmt',
        meta: {
          title: '设备管理',
          icon: 'cluster',
          appCode: 'water-works-wisdom',
          permission: ['water-works-device-management']
        },
        component: RouteView,
        children: [
          {
            path: '/water-works/workbench/deviceMgmt/DeviceMgmt',
            name: 'DeviceMgmts',
            component: () => import('@/views/waterWorks/workbench/deviceMgmt/DeviceMgmt.vue'),
            meta: { title: '设备管理', icon: 'tool', keepAlive: true, permission: ['water-works-device-managements'] }
          },
          {
            path: '/water-works/workbench/deviceMgmt/DeviceOLog',
            name: 'DeviceOLog',
            component: () => import('@/views/waterWorks/workbench/deviceMgmt/DeviceOLog.vue'),
            meta: {
              title: '设备操作记录',
              icon: 'file-search',
              keepAlive: true,
              permission: ['water-works-device-o-log']
            }
          }
        ]
      },
      {
        // 智慧水厂 - 报警管理
        path: '/water-works/workbench/alarmMgmt',
        name: 'AlarmManagement',
        meta: {
          title: '报警管理',
          icon: 'exclamation-circle',
          appCode: 'water-works-wisdom',
          permission: ['water-works-alarm-management']
        },
        component: RouteView,
        children: [
          {
            path: '/water-works/workbench/alarmMgmt/AlarmListData',
            name: 'AlarmListData',
            component: () => import('@/views/waterWorks/workbench/alarmMgmt/AlarmListData.vue'),
            meta: {
              title: '报警列表',
              icon: 'file-excel',
              keepAlive: true,
              permission: ['water-works-alarm-list-data']
            }
          },
          {
            path: '/water-works/workbench/alarmMgmt/AlarmSetting',
            name: 'AlarmSetting',
            component: () => import('@/views/waterWorks/workbench/alarmMgmt/AlarmSetting.vue'),
            meta: { title: '报警设置', icon: 'select', keepAlive: true, permission: ['water-works-alarm-setting'] }
          }
        ]
      },
      {
        //历史数据
        path: '/water-works/workbench/historicalData',
        name: 'HistoricalData',
        meta: {
          title: '历史数据',
          icon: 'history',
          appCode: 'water-works-wisdom',
          permission: ['water-works-history-data']
        },
        component: RouteView,
        children: [
          {
            path: '/water-works/workbench/historicalData/FacilityHistoricalData',
            name: 'FacilityHistoricalData',
            component: () => import('@/views/waterWorks/workbench/historicalData/FacilityHistoricalData.vue'),
            meta: { title: '历史数据', icon: 'database', keepAlive: true, permission: ['facility-historical-data'] }
          }
        ]
      },
      {
        //智慧水厂 - 水厂安防
        path: '/water-works/workbench/securityProtection',
        name: 'SecurityProtection',
        meta: {
          title: '水厂安防',
          icon: 'safety-certificate',
          appCode: 'water-works-wisdom',
          permission: ['water-works-security-protection']
        },
        component: RouteView,
        children: [
          {
            path: '/water-works/workbench/securityProtection/DeployControl',
            name: 'DeployControl',
            component: () => import('@/views/waterWorks/workbench/securityProtection/DeployControl.vue'),
            meta: { title: '安防布控', icon: 'insurance', keepAlive: true, permission: ['deploy-control'] }
          },
          {
            path: '/water-works/workbench/securityProtection/Records',
            name: 'Records',
            component: () => import('@/views/waterWorks/workbench/securityProtection/Records.vue'),
            meta: { title: '安防记录', icon: 'security-scan', keepAlive: true, permission: ['records'] }
          }
        ]
      },
      {
        //智慧水厂 - 配置管理
        path: '/water-works/workbench/configuration',
        name: 'Configuration',
        meta: {
          title: '配置管理',
          icon: 'setting',
          appCode: 'water-works-wisdom',
          permission: ['water-works-configuration-management']
        },
        component: RouteView,
        children: [
          {
            path: '/water-works/workbench/configuration/HdpiConfiguration',
            name: 'HdpiConfiguration',
            component: () => import('@/views/waterWorks/workbench/configuration/HdpiConfiguration.vue'),
            meta: { title: '大屏配置', icon: 'video-camera', keepAlive: true, permission: ['hdpi-configuration'] }
          },
          {
            path: '/water-works/workbench/configuration/TypeConfiguration',
            name: 'TypeConfiguration',
            component: () => import('@/views/waterWorks/workbench/configuration/TypeConfiguration.vue'),
            meta: { title: '设备类型配置', icon: 'book', keepAlive: true, permission: ['type-configuration'] }
          }
        ]
      },
      {
        // 智慧水厂 - 值班安排
        path: '/water-works/workbench/beOnDuty',
        name: 'DeOnDuty',
        meta: {
          title: '值班安排',
          icon: 'reconciliation',
          appCode: 'water-works-wisdom',
          permission: ['water-works-be-on-duty'],
          component: () => import('@/views/waterWorks/workbench/beOnDuty/DeOnDuty.vue')
        }
      },

      // 压力监测系统
      {
        path: '/pressure/index',
        name: 'PressureMap',
        meta: {
          title: '首页',
          icon: 'environment',
          permission: ['pressure-data-manager'],
          appCode: 'pressure'
        },
        component: () => import('@/views/pressure/workbench/IndexMap')
      },
      {
        path: '/pressure',
        name: 'Pressure',
        component: RouteView,
        meta: {
          title: '测点数据',
          icon: 'setting',
          permission: ['pressure-data-manager'],
          appCode: 'pressure'
        },
        redirect: '/pressure/piezometer/index',
        children: [
          {
            path: '/pressure/piezometer/index',
            name: 'piezometer',
            component: () => import('@/views/pressure/PiezometerList'),
            meta: { title: '远传压力表', icon: 'tool', keepAlive: true, permission: ['piezometer'] }
          },
          {
            path: '/pressure/piezometer/data/history',
            name: 'piezometerDataHistory',
            component: () => import('@/views/pressure/PiezometerDataHistoryList'),
            meta: { title: '压力数据', icon: 'tool', keepAlive: true, permission: ['piezometer'] }
          }
        ]
      },
      {
        path: '/pressure/workbench',
        name: 'PressureWorkBench',
        component: RouteView,
        meta: {
          title: '监测报表',
          icon: 'dashboard',
          permission: ['pressure-data-manager'],
          appCode: 'pressure'
        },
        redirect: '/pressure/workbench/MonitoringCurve',
        children: [
          {
            path: '/pressure/workbench/PressureDetection',
            name: 'PressureDetection',
            component: () => import('@/views/pressure/workbench/PressureDetection'),
            meta: { title: '压力监测', icon: 'tool', keepAlive: true, permission: ['PressureDetection'] }
          },
          {
            path: '/pressure/workbench/MonitoringCurve',
            name: 'MonitoringCurve',
            component: () => import('@/views/pressure/workbench/MonitoringCurve'),
            meta: { title: '监测曲线', icon: 'tool', keepAlive: true, permission: ['MonitoringCurve'] }
          }
        ]
      },
      {
        path: '/pressure-alarm-management',
        name: 'PressureAlarmManagement',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['pressure-data-manager'],
          appCode: 'pressure'
        },
        redirect: '/pressure-alarm-management/pressure-alarm-list',
        children: [
          {
            path: '/pressure-alarm-list',
            name: 'pressure-alarm-list',
            component: RouteView,
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['pressure-alarm-list'] },
            children: [
              {
                path: '/pressure-alarm-management/pressure-alarm-list',
                name: 'PressureAlarmList',
                component: () => import('@/views/pressure-alarm-management/pressure-alarm-list'),
                meta: {
                  title: '数据上下限报警列表',
                  icon: 'tool',
                  keepAlive: true,
                  permission: ['pressure-alarm-list']
                }
              },
              {
                path: '/pressure-alarm-management/pressure-interrupt-list',
                name: 'PressureInterruptList',
                component: () => import('@/views/pressure-alarm-management/pressure-interrupt-list'),
                meta: {
                  title: '数据上传中断报警列表',
                  icon: 'tool',
                  keepAlive: true,
                  permission: ['pressure-alarm-list']
                }
              }
            ]
          },
          {
            path: '/pressure-alarm-set',
            name: 'pressure-alarm-set',
            component: RouteView,
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['pressure-alarm-set'] },
            children: [
              {
                path: '/pressure-alarm-management/pressure-alarm-set',
                name: 'PressureAlarmSet',
                component: () => import('@/views/pressure-alarm-management/pressure-alarm-set'),
                meta: { title: '数据上下限报警设置', icon: 'tool', keepAlive: true, permission: ['pressure-alarm-set'] }
              },
              {
                path: '/pressure-alarm-management/pressure-interrupt-set',
                name: 'PressureInterruptSet',
                component: () => import('@/views/pressure-alarm-management/pressure-interrupt-set'),
                meta: {
                  title: '数据上传中断报警设置',
                  icon: 'tool',
                  keepAlive: true,
                  permission: ['pressure-alarm-set']
                }
              }
            ]
          }
        ]
      },
      // 预警报警系统
      {
        path: '/warning-alarm/workbench',
        redirect: '/Early-warning-alarm-large-screen',
        name: 'EarlyWarningAlarmLargeScreen',
        meta: {
          title: '预警报警大屏',
          keepAlive: false,
          target: '_blank',
          icon: 'environment',
          permission: ['warning-alarm'],
          appCode: 'warning-alarm'
        }
      },
      {
        path: '/alarm-list',
        name: 'AlarmList',
        meta: {
          title: '报警列表',
          icon: 'setting',
          permission: ['alarm-list'],
          appCode: 'warning-alarm'
        },
        component: () => import('@/views/warning-alarm/alarm-list')
      },
      {
        path: '/maintenance',
        name: 'maintenanceDashboard',
        meta: {
          title: '首页',
          icon: 'home',
          permission: ['patrol_Index'],
          appCode: 'patrol_maintenance'
        },
        component: () => import('@/views/maintenance/workbench/Index')
      },
      {
        path: '/maintenance/event/managementt',
        name: 'event_management',
        meta: { title: '事件管理', icon: 'setting', permission: ['event-management'], appCode: 'patrol_maintenance' },
        component: () => import('@/views/maintenance/EventManagement/EventManagement')
      },
      {
        path: '/maintenance/task/management',
        name: 'task_management',
        meta: {
          title: '任务管理',
          icon: 'setting',
          permission: ['task_management'],
          appCode: 'patrol_maintenance'
        },
        component: () => import('@/views/maintenance/TaskManagement/TaskManagement')
      },
      {
        path: '/maintenance/order',
        name: 'OrderManagement_1',
        component: RouteView,
        meta: {
          title: '工单管理',
          icon: 'setting',
          permission: ['OrderManagement'],
          appCode: 'patrol_maintenance'
        },
        redirect: '/maintenance/order/management',
        children: [
          {
            path: '/maintenance/order/management',
            name: 'order_management',
            component: () => import('@/views/maintenance/OrderManagement/OrderManagement'),
            meta: { title: '工单管理', icon: 'tool', keepAlive: true, permission: ['order_management'] }
          },
          {
            path: '/maintenance/order/consumables',
            name: 'maintenance_consumables',
            component: () => import('@/views/maintenance/Consumables/Consumables'),
            meta: { title: '维修耗材', icon: 'tool', keepAlive: true, permission: ['maintenance_consumables'] }
          }
        ]
      },
      {
        path: '/maintenance/patrol',
        name: 'PatrolManagement',
        component: RouteView,
        meta: {
          title: '巡检养护',
          icon: 'setting',
          permission: ['PatrolManagement'],
          appCode: 'patrol_maintenance'
        },
        redirect: '/maintenance/patrol/management',
        children: [
          {
            path: '/maintenance/patrol/management',
            name: 'patrol_management',
            component: () => import('@/views/maintenance/PatrolManagement/PatrolManagement'),
            meta: { title: '巡检计划', icon: 'tool', keepAlive: true, permission: ['patrol_management'] }
          },
          {
            path: '/maintenance/Equipment',
            name: 'Equipment_management',
            component: () => import('@/views/maintenance/Equipment/Equipment'),
            meta: { title: '设备养护计划', icon: 'tool', keepAlive: true, permission: ['Equipment_management'] }
          }
        ]
      },

      {
        path: '/maintenance/approval',
        name: 'ApprovalManagement',
        component: RouteView,
        meta: {
          title: '审批管理',
          icon: 'setting',
          permission: ['ApprovalManagement'],
          appCode: 'patrol_maintenance'
        },
        redirect: '/maintenance/approval/Pending',
        children: [
          {
            path: '/maintenance/approval/pending',
            name: 'approval_pending',
            component: () => import('@/views/maintenance/ApprovalManagement/ApprovalPending'),
            meta: { title: '待审批', icon: 'tool', keepAlive: true, permission: ['patrol_pending'] }
          },
          {
            path: '/maintenance/approval/pass',
            name: 'approval_pass',
            component: () => import('@/views/maintenance/ApprovalManagement/ApprovalPass'),
            meta: { title: '审批通过', icon: 'tool', keepAlive: true, permission: ['patrol_pass'] }
          },
          {
            path: '/maintenance/approval/fail',
            name: 'approval_fail',
            component: () => import('@/views/maintenance/ApprovalManagement/ApprovalFail'),
            meta: { title: '审批未通过', icon: 'tool', keepAlive: true, permission: ['patrol_fail'] }
          }
        ]
      },
      // 抄表系统

      {
        path: '/meter-reading',
        name: 'UserManagement',
        meta: {
          title: '用户管理',
          icon: 'team',
          permission: ['meter-reader-user'],
          appCode: 'meter-reading'
        },
        component: () => import('@/views/meter-reading/userManagement')
      },
      {
        path: '/meterReaderManage',
        name: 'MeterReaderManage',
        meta: {
          title: '抄表员管理',
          icon: 'user',
          permission: ['Meter-reader-manage'],
          appCode: 'meter-reading'
        },
        component: () => import('@/views/meter-reading/meterReaderManage')
      },

      {
        path: '/statisticalForms',
        name: 'statisticalForms',
        meta: {
          title: '表册管理',
          icon: 'book',
          permission: ['statistical-forms'],
          appCode: 'meter-reading'
        },
        component: () => import('@/views/meter-reading/statisticalForms')
      },
      {
        path: '/meterReadingManage',
        name: 'MeterReadingManage',
        component: RouteView,
        meta: {
          title: '抄表管理',
          icon: 'reconciliation',
          permission: ['meter-reading-management'],
          appCode: 'meter-reading'
        },
        children: [
          {
            path: '/task',
            name: 'taskplan',
            meta: {
              title: '抄表计划',
              icon: 'file-done',
              permission: ['meter-reading-plan'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/task')
          },
          {
            path: '/temporaryMeterReading',
            name: 'TemporaryMeterReading',
            meta: {
              title: '临时抄表',
              icon: 'file-done',
              permission: ['temporary-meter-reading'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/temporaryMeterReading')
          },
          {
            path: '/meterReadingTask',
            name: 'MeterReadingTask',
            component: RouteView,
            meta: {
              title: '抄表任务',
              icon: 'schedule',
              permission: ['meter-reading-task'],
              appCode: 'meter-reading'
            },
            children: [
              {
                path: '/meter-reading/dataCatalogOverview',
                name: 'dataCatalogOverview',
                meta: {
                  title: '抄表数据总览',
                  icon: 'pie-chart',
                  permission: ['meter-reading-dataOverview'],
                  appCode: 'meter-reading'
                },
                component: () => import('@/views/meter-reading/dataCatalogOverview')
              },
              {
                path: '/taskDetails',
                name: 'TaskDetails',
                meta: {
                  title: '任务明细',
                  icon: 'schedule',
                  permission: ['meter-reading-taskdetails'],
                  appCode: 'meter-reading'
                },
                component: () => import('@/views/meter-reading/taskDetails')
              }
            ]
          },
          {
            path: '/meterReadingReview',
            name: 'MeterReadingReview',
            meta: {
              title: '抄表审核',
              icon: 'file-search',
              permission: ['meter-reading-review'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/meterReadingReview')
          },
          {
            path: '/reviewLog',
            name: 'Reviewlog',
            meta: {
              title: '复核日志',
              icon: 'reload',
              permission: ['meter-reading-reviewlog'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/reviewLog')
          }
        ]
      },
      {
        path: '/meterHistory',
        name: 'MeterHistory',
        component: RouteView,
        meta: {
          title: '历史数据',
          icon: 'history',
          permission: ['meter-history'],
          appCode: 'meter-reading'
        },
        children: [
          {
            path: '/mechanicalMeter',
            name: 'MechanicalMeter',
            meta: {
              title: '机械表历史数据',
              icon: 'history',
              permission: ['mechanicalMeter'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/mechanicalMeter')
          },
          {
            path: '/remoteMeter',
            name: 'RemoteMeter',
            meta: {
              title: '远传表历史数据',
              icon: 'history',
              permission: ['remoteMeter'],
              appCode: 'meter-reading'
            },
            component: () => import('@/views/meter-reading/remoteMeter')
          }
        ]
      },
      {
        path: '/dataAnalysis',
        name: 'dataAnalysis',
        appCode: 'dataAnalysis',
        meta: {
          title: '数据分析',
          icon: 'line-chart',
          appCode: 'meter-reading'
        },
        component: () => import('@/views/meter-reading/dataAnalysis')
      },

      // 营收系统
      // {
      //   path: '/revenue',
      //   name: 'RevenueUser',
      //   component: RouteView,
      //   meta: {
      //     title: '用户管理',
      //     icon: 'user',
      //     permission: ['revenue_user'],
      //     appCode: 'revenue_system',
      //   },
      //   children: [
      //     {
      //       path: '/revenue/user/overview',
      //       name: 'RevenueUserOverview',
      //       component: () => import('@/views/revenue/user/OverView'),
      //       meta: { title: '用户总览', icon: 'tool', keepAlive: true, permission: ['revenue_user_overview'] },
      //     },
      //     {
      //       path: '/revenue/user/putinfile',
      //       name: 'RevenueUserPutInfile',
      //       component: () => import('@/views/revenue/user/PutInFile'),
      //       meta: { title: '用户建档', icon: 'tool', keepAlive: true, permission: ['revenue_user_putinfile'] },
      //     },
      //   ],
      // },
      // {
      //   path: '/revenue/power',
      //   name: 'RevenuePower',
      //   meta: {
      //     title: '权限管理',
      //     icon: 'laptop',
      //     permission: ['revenue_power'],
      //     appCode: 'revenue_system',
      //   },
      //   component: () => import('@/views/revenue/Power'),
      // },
      // {
      //   path: '/revenue/device',
      //   name: 'RevenueDevice',
      //   meta: {
      //     title: '设备管理',
      //     icon: 'laptop',
      //     permission: ['revenue_device'],
      //     appCode: 'revenue_system',
      //   },
      //   component: () => import('@/views/revenue/Device'),
      // },
      // 二次供水
      {
        path: '/Secondary-water/frontpage',
        name: 'Secondarywater',
        meta: {
          title: '首页',
          icon: 'notification',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/frontpage')
      },
      {
        path: '/Pumproom-management',
        name: 'Pumproom',
        meta: {
          title: '泵房管理',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/Pumproom-management')
      },
      {
        path: '/Equipment-management',
        name: 'Equipment',
        meta: {
          title: '设备管理',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/Equipment-management')
      },
      {
        path: '/DeviceHistoryData',
        name: 'DeviceHistoryData',
        meta: {
          title: '设备历史数据',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/DeviceHistoryData')
      },
      {
        path: '/twice-alarm-management',
        name: 'TwiceAlarmManagement',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        redirect: '/twice-alarm-management/twice-alarm-list',
        children: [
          {
            path: '/twice-alarm-management/twice-alarm-list',
            name: 'TwiceAlarmList',
            component: () => import('@/views/twice-alarm-management/twice-alarm-list'),
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['twice-alarm-list'] }
          },
          {
            path: '/twice-alarm-management/twice-alarm-set',
            name: 'TwiceAlarmSet',
            component: () => import('@/views/twice-alarm-management/twice-alarm-set'),
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['twice-alarm-set'] }
          }
        ]
      },
      {
        path: '/Monitoring',
        name: 'Monitoring',
        meta: {
          title: '监控管理',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/management')
      },
      {
        path: '/Monitoring-configuration',
        name: 'Mconfiguration',
        meta: {
          title: '监控配置',
          icon: 'setting',
          permission: ['Secondary-water'],
          appCode: 'Secondary-water'
        },
        component: () => import('@/views/Secondary-water/Monitoring-configuration')
      },
      {
        path: '/Secondary-water/patrol',
        name: 'waterPatrolManagement',
        component: RouteView,
        meta: {
          title: '巡检养护',
          icon: 'setting',
          permission: ['waterPatrolManagement'],
          appCode: 'Secondary-water'
        },
        redirect: '/Secondary-water/patrol/management',
        children: [
          {
            path: '/Secondary-water/patrol/management',
            name: 'water_patrol_management',
            component: () => import('@/views/Secondary-water/PatrolManagement/PatrolManagement'),
            meta: { title: '巡检养护', icon: 'tool', keepAlive: true, permission: ['water_patrol_management'] }
          },
          {
            path: '/Secondary-water/task/management',
            name: 'water_task_management',
            component: () => import('@/views/Secondary-water/TaskManagement/TaskManagement'),
            meta: { title: '任务管理', icon: 'tool', keepAlive: true, permission: ['water_task_management'] }
          },
          {
            path: '/Secondary-water/order/management',
            name: 'water_order_management',
            component: () => import('@/views/Secondary-water/OrderManagement/OrderManagement'),
            meta: { title: '工单管理', icon: 'tool', keepAlive: true, permission: ['water_order_management'] }
          },
          {
            path: '/Secondary-water/order/consumables',
            name: 'Secondary_water_consumables',
            component: () => import('@/views/Secondary-water/Consumables/Consumables'),
            meta: { title: '维修耗材', icon: 'tool', keepAlive: true, permission: ['Secondary_water_consumables'] }
          },
          {
            path: '/Secondary-water/approval/administration',
            name: 'administration',
            component: () => import('@/views/Secondary-water/ApprovalManagement/administration'),
            meta: { title: '审批管理', icon: 'tool', keepAlive: true, permission: ['water_patrol_pending'] }
          }
        ]
      },
      // 	区域停水管控
      {
        path: '/Water-outage-control',
        redirect: '/water-new-one-map',
        name: 'waterNewOneMapReal',
        meta: {
          title: '区域停水管控全览图',
          keepAlive: false,
          target: '_blank',
          appCode: 'Water-outage-control',
          icon: 'environment',
          permission: ['water-new-one-map']
        }
      },
      {
        path: '/MobileMap',
        redirect: '/MobileMap',
        name: 'Mobilemap',
        meta: {
          title: '移动端区域停水管控',
          keepAlive: false,
          target: '_blank',
          appCode: 'Water-outage-control',
          icon: 'environment',
          permission: ['MobileMap']
        }
      },
      {
        path: '/water-pipe-network',
        name: 'water-pipe-network',
        component: RouteView,
        meta: {
          title: '物探点线数据',
          icon: 'setting',
          permission: ['water-pipe-network-gis'],
          appCode: 'Water-outage-control'
        },
        redirect: '/Water-outage-control/Wateroutage-control/GisPipeNetworkList',
        children: [
          {
            path: '/Water-outage-control/Wateroutage-control/GisPipeNetworkList',
            name: 'GisPipeNetworkList',
            component: () => import('@/views/Water-outage-control/Wateroutage-control/GisPipeNetworkList'),
            meta: { title: '物探点数据', icon: 'setting', keepAlive: true, permission: ['Water-network-data'] }
          },
          {
            path: '/Water-outage-control/Wateroutage-control/GisPipeLineLayer',
            name: 'PipeLineLayer',
            component: () => import('@/views/Water-outage-control/Wateroutage-control/GisPipeLineLayer'),
            meta: { title: '管线数据', icon: 'setting', keepAlive: true, permission: ['Water-line-layer'] }
          }
        ]
      },
      {
        path: '/water-pipe-network/waterMeter',
        name: 'waterMeter_1',
        component: RouteView,
        meta: {
          title: '水表管理',
          icon: 'setting',
          permission: ['water-pipe-network-water-meters'],
          appCode: 'Water-outage-control'
        },
        redirect: '/Water-outage-control/waterMeter/GisClassUserWaterMeter',
        children: [
          {
            path: '/Water-outage-control/waterMeter/GisClassUserWaterMeter',
            name: 'GisClassUserWaterMeter',
            component: () => import('@/views/Water-outage-control/waterMeter/GisClassUserWaterMeter'),
            meta: {
              title: '新分类编码用户水表',
              icon: 'tool',
              keepAlive: true,
              permission: ['water-gis-class-user-water-meter']
            }
          }
        ]
      },
      {
        path: '/Water-outage-control/Water-outage',
        name: 'Wateroutage_2',
        component: RouteView,
        meta: {
          title: '互通阀门管理',
          icon: 'setting',
          permission: ['Water-outage'],
          appCode: 'Water-outage-control'
        },
        redirect: '/Water-outage-control/Water-outager',
        children: [
          {
            path: '/Water-outage-control/Water-outage',
            name: 'Wateroutage',
            component: () => import('@/views/Water-outage-control/Water-outage'),
            meta: { title: '互通阀门设置', icon: 'tool', keepAlive: true, permission: ['Water-outage'] }
          }
        ]
      },
      {
        path: '/Water-outage-control/Water-outage-management',
        name: 'Wateroutagemanagement',
        component: RouteView,
        meta: {
          title: '停水事件管理',
          icon: 'setting',
          permission: ['Water-outage-management'],
          appCode: 'Water-outage-control'
        },
        redirect: '/Water-outage-control/Water-outage-management',
        children: [
          {
            path: '/Water-outage-control/Water-outage-management',
            name: 'Wateroutagemanagement',
            component: () => import('@/views/Water-outage-control/Water-outage-management'),
            meta: { title: '停水管控事件', icon: 'tool', keepAlive: true, permission: ['Water-outage-management'] }
          }
        ]
      },
      {
        path: '/Water-outage-control/messagelog',
        name: 'messagelog',
        component: RouteView,
        meta: {
          title: '消息管理',
          icon: 'setting',
          permission: ['messagelog'],
          appCode: 'Water-outage-control'
        },
        redirect: '/Water-outage-control/messagelog',
        children: [
          {
            path: '/Water-outage-control/messagelog',
            name: 'messagelog',
            component: () => import('@/views/Water-outage-control/messagelog'),
            meta: { title: '消息发送记录', icon: 'tool', keepAlive: true, permission: ['messagelog'] }
          },
          {
            path: '/Water-outage-control/message-template',
            name: 'messagetemplate',
            component: () => import('@/views/Water-outage-control/message-template'),
            meta: { title: '消息模板', icon: 'tool', keepAlive: true, permission: ['messagetemplate'] }
          }
        ]
        // component: () => import('@/views/Water-outage-control/messagelog')
      },
      //采集成图一体化系统
      {
        path: '/gather-mapping/ProjectData',
        name: 'messagelog',
        component: RouteView,
        meta: {
          title: '采集项目',
          icon: 'cloud-server',
          permission: ['renumber'],
          appCode: 'gather-mapping'
        },
        redirect: '/gather-mapping/ProjectData',
        children: [
          {
            path: '/gather-mapping/ProjectData',
            name: 'ProjectData',
            meta: {
              title: '采集项目列表',
              icon: 'cloud-server',
              permission: ['project-data'],
              appCode: 'gather-mapping'
            },
            component: () => import('@/views/gather-mapping/ProjectData')
          }
        ]
      },
      {
        path: '/gather-mapping/CoordinateMatching',
        name: 'messagelog',
        component: RouteView,
        meta: {
          title: '坐标匹配',
          icon: 'cloud-server',
          permission: ['CoordinateMatching'],
          appCode: 'gather-mapping'
        },
        redirect: '/gather-mapping/CoordinateMatching',
        children: [
          {
            path: '/gather-mapping/CoordinateMatching',
            name: 'CoordinateMatching',
            meta: {
              title: '坐标匹配',
              icon: 'environment',
              permission: ['CoordinateMatching'],
              appCode: 'CoordinateMatching'
            },
            component: () => import('@/views/gather-mapping/CoordinateMatching')
          },
          // {
          //   path: '/gather-mapping/CoordinateMatchingList',
          //   name: 'CoordinateMatchingList',
          //   meta: {
          //     title: '坐标匹配列表',
          //     icon: 'cloud-server',
          //     permission: ['gather-mapping'],
          //     appCode: 'gather-mapping',
          //   },
          //   component: () => import('@/views/gather-mapping/CoordinateMatchingList'),
          // },
          {
            path: '/gather-mapping/Renumber',
            name: 'Renumber',
            meta: {
              title: '重新编号',
              icon: 'reload',
              permission: ['renumber'],
              appCode: 'gather-mapping'
            },
            component: () => import('@/views/gather-mapping/Renumber')
          }
        ]
      },
      {
        path: '/gather-mapping/PipelineMapping',
        name: 'messagelog',
        component: RouteView,
        meta: {
          title: '管线成图',
          icon: 'picture',
          permission: ['pipeline-mapping'],
          appCode: 'gather-mapping'
        },
        redirect: '/gather-mapping/PipelineMapping',
        children: [
          {
            path: '/gather-mapping/PipelineMapping',
            name: 'PipelineMapping',
            meta: {
              title: '管线成图',
              icon: 'picture',
              permission: ['pipeline-mapping'],
              appCode: 'gather-mapping'
            },
            component: () => import('@/views/gather-mapping/PipelineMapping')
          },

          {
            path: '/gather-mapping/EditModel',
            name: 'EditModel',
            meta: {
              title: '模板编辑',
              icon: 'file-protect',
              permission: ['editModel'],
              appCode: 'editModel'
            },
            component: () => import('@/views/gather-mapping/EditModel')
          },
          {
            path: '/PipelineMappingList',
            name: 'PipelineMappingList',
            component: () => import('@/views/gather-mapping/PipelineMappingList'),
            appCode: 'gather-mapping',
            meta: { title: '管线成图列表', icon: 'picture', permission: ['PipelineMappingList'] }
          }
        ]
      },

      // {
      //   path: '/gather-mapping/DataConversion',
      //   name: 'DataConversion',
      //   meta: {
      //     title: '数据转换', icon: 'sync', permission: ['data-conversion'], appCode: 'gather-mapping'
      //   },
      //   component: () => import('@/views/gather-mapping/DataConversion')
      // },

      // 用户配置
      {
        path: '/gather-mapping/tenant-information-configuration',
        name: 'TenantInformationConfiguration',
        component: RouteView,
        meta: {
          title: '用户管理',
          icon: 'solution',
          permission: ['tenant-information-configuration'],
          appCode: 'gather-mapping'
        },
        redirect: '/gather-mapping/tenant-information-configuration/UserConfiguration',
        // 采集成图一体化系统用户配置
        children: [
          // 用户配置列表
          {
            path: '/gather-mapping/tenant-information-configuration/UserConfiguration',
            name: 'UserConfiguration',
            component: () => import('@/views/gather-mapping/tenant-information-configuration/UserConfiguration'),
            meta: { title: '用户配置列表', icon: 'tool', keepAlive: true, permission: ['user-configuration'] }
          },

          //用户登入信息配置表
          {
            path: '/gather-mapping/tenant-information-configuration/UserLoginInformation',
            name: 'UserLoginInformation',
            component: () => import('@/views/gather-mapping/tenant-information-configuration/UserLoginInformation'),
            meta: { title: '用户登入记录', icon: 'tool', keepAlive: true, permission: ['user-login-information'] }
          }
        ]
      },
      //基础信息配置
      {
        path: '/gather-mapping/underlying-configuration',
        name: 'UnderlyingConfiguration',
        component: RouteView,
        meta: {
          title: '基础信息配置',
          icon: 'setting',
          permission: ['underlying-configuration'],
          appCode: 'gather-mapping'
        },
        redirect: '/gather-mapping/underlying-configuration/TubingSetting',
        children: [
          {
            path: '/gather-mapping/underlying-configuration/TubingSetting',
            name: 'TubingSetting',
            component: () => import('@/views/gather-mapping/underlying-configuration/TubingSetting'),
            meta: { title: '管类设置', icon: 'tool', keepAlive: true, permission: ['tubing-setting'] }
          },
          {
            path: '/gather-mapping/underlying-configuration/PropertySetting',
            name: 'PropertySetting',
            component: () => import('@/views/gather-mapping/underlying-configuration/PropertySetting'),
            meta: { title: '属性设置', icon: 'tool', keepAlive: true, permission: ['property-setting'] }
          },
          {
            path: '/gather-mapping/underlying-configuration/ElementSetting',
            name: 'ElementSetting',
            component: () => import('@/views/gather-mapping/underlying-configuration/ElementSetting'),
            meta: { title: '要素设置', icon: 'tool', keepAlive: true, permission: ['element-setting'] }
          },
          {
            path: '/gather-mapping/underlying-configuration/DebuggingSetting',
            name: 'DebuggingSetting',
            component: () => import('@/views/gather-mapping/underlying-configuration/DebuggingSetting'),
            meta: { title: '查错设置', icon: 'tool', keepAlive: true, permission: ['debugging-setting'] }
          }
        ]
      },

      // 工程管理
      {
        path: '/project-Managements/Project-Home',
        name: 'ProjectHome',
        meta: {
          title: '首页',
          icon: 'setting',
          permission: ['project-Managements'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/Project-Home')
      },
      {
        path: '/project-Managements/Pre-PA',
        name: 'PrePA',
        meta: {
          title: '项目申请/立项',
          icon: 'setting',
          permission: ['Pre-PA'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/Pre-PA')
      },
      {
        path: '/project-Managements/survey-and-design',
        name: 'SurveyAndDesign',
        meta: {
          title: '勘察设计',
          icon: 'setting',
          permission: ['survey-and-design'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/survey-and-design')
      },
      {
        path: '/project-Managements/project-construction',
        name: 'ProjectConstruction',
        meta: {
          title: '项目施工',
          icon: 'setting',
          permission: ['project-construction'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/project-construction')
      },
      {
        path: '/project-Managements/project-acceptance',
        name: 'ProjectAcceptance',
        meta: {
          title: '项目验收',
          icon: 'setting',
          permission: ['project-acceptance'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/project-acceptance')
      },
      {
        path: '/project-Managements/material-statistics',
        name: 'MaterialStatistics',
        meta: {
          title: '材料统计',
          icon: 'setting',
          permission: ['material-statistics'],
          appCode: 'project-Managements'
        },
        component: () => import('@/views/project-Managements/material-statistics')
      },
      // 水源监测系统
      {
        path: '/Water-source-monitoring/source-monitoring-Home',
        redirect: '/WaterSourceMonitoring',
        name: 'WaterSourceMonitoring',
        meta: {
          title: '水源监测系统',
          keepAlive: false,
          target: '_blank',
          icon: 'environment',
          permission: ['Water-source-monitoring'],
          appCode: 'Water-source-monitoring'
        }
      },
      {
        path: '/report-management/Equipment-managements',
        name: 'Equipment-managements',
        meta: {
          title: '设备管理',
          icon: 'setting',
          permission: ['Equipment-managements'],
          appCode: 'Water-source-monitoring'
        },
        component: () => import('@/views/report-management/Equipment-managements')
      },
      {
        path: '/Water-source-monitoring',
        name: 'Water-source-monitoring',
        component: RouteView,
        meta: {
          title: '监控管理',
          icon: 'setting',
          permission: ['Water-source-monitoring'],
          appCode: 'Water-source-monitoring'
        },
        redirect: '/Water-source-monitoring/Monitoring-Management',
        children: [
          {
            path: '/Water-source-monitoring/Monitoring-Management',
            name: 'Monitoring-Management',
            component: () => import('@/views/Water-source-monitoring/Monitoring-Management'),
            meta: { title: '视频管理', icon: 'tool', keepAlive: true, permission: ['Monitoring-Management'] }
          },
          {
            path: '/Water-source-monitoring/Monitoring-Setting',
            name: 'Monitoring-Setting',
            component: () => import('@/views/Water-source-monitoring/Monitoring-Setting'),
            meta: { title: '监控设置', icon: 'tool', keepAlive: true, permission: ['Monitoring-Setting'] }
          }
        ]
      },
      {
        path: '/source-alarm-management',
        name: 'SourceAlarmManagement',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['Water-source-monitoring'],
          appCode: 'Water-source-monitoring'
        },
        redirect: '/source-alarm-management/source-alarm-list',
        children: [
          {
            path: '/source-alarm-management/source-alarm-list',
            name: 'SourceAlarmList',
            component: () => import('@/views/source-alarm-management/source-alarm-list'),
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['source-alarm-list'] }
          },
          {
            path: '/source-alarm-management/source-alarm-set',
            name: 'SourceAlarmSet',
            component: () => import('@/views/source-alarm-management/source-alarm-set'),
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['source-alarm-set'] }
          }
        ]
      },
      {
        path: '/report-management',
        name: 'report-management',
        component: RouteView,
        meta: {
          title: '报表管理',
          icon: 'setting',
          permission: ['Water-source-monitoring'],
          appCode: 'Water-source-monitoring'
        },
        redirect: '/report-management/water-level-report',
        children: [
          {
            path: '/report-management/water-level-report',
            name: 'WaterLevelReport',
            component: () => import('@/views/report-management/water-level-report'),
            meta: { title: '水位报表', icon: 'tool', keepAlive: true, permission: ['water-level-report'] }
          },
          {
            path: '/report-management/water-quality-report',
            name: 'WaterQualityReport',
            component: () => import('@/views/report-management/water-quality-report'),
            meta: { title: '水质报表', icon: 'tool', keepAlive: true, permission: ['water-quality-report'] }
          }
        ]
      },
      {
        path: '/historical-data',
        name: 'HistoricalData',
        component: RouteView,
        meta: {
          title: '历史数据',
          icon: 'setting',
          permission: ['Water-source-monitoring'],
          appCode: 'Water-source-monitoring'
        },
        redirect: '/historical-data/equipment-history',
        children: [
          {
            path: '/historical-data/equipment-history',
            name: 'EquipmentHistory',
            component: () => import('@/views/historical-data/equipment-history'),
            meta: { title: '设备历史', icon: 'tool', keepAlive: true, permission: ['equipment-history'] }
          },
          {
            path: '/historical-data/alarm-history',
            name: 'AlarmHistory',
            component: () => import('@/views/historical-data/alarm-history'),
            meta: { title: '报警历史', icon: 'tool', keepAlive: true, permission: ['alarm-history'] }
          }
        ]
      },
      // 水厂智能化
      {
        path: '/Intelligent-water-plant/System-settings',
        redirect: '/WaterWorksVisualization',
        name: 'water-works-visualiztion',
        meta: {
          title: '水厂智能化大屏',
          keepAlive: false,
          target: '_blank',
          icon: 'environment',
          permission: ['Intelligent-water-plant'],
          appCode: 'Intelligent-water-plant'
        }
      },
      // {
      //   path: '/Intelligent-water-plant/System-settings',
      //   name: 'Systemsettings',
      //   meta: {
      //     title: '首页', icon: 'setting', permission: ['Intelligent-water-plant'], appCode: 'Intelligent-water-plant'
      //   },
      //   component: () => import('@/views/Intelligent-water-plant/System-settings')
      // },
      {
        path: '/Intelligent-water-plant/Equipment-management',
        name: 'Equipmentt',
        meta: {
          title: '设备管理',
          icon: 'setting',
          permission: ['Intelligent-water-plant'],
          appCode: 'Intelligent-water-plant'
        },
        component: () => import('@/views/Intelligent-water-plant/Equipment-managements')
      },
      {
        path: '/Intelligent-water-plant-report',
        name: 'IntelligentWaterPlantReport',
        component: RouteView,
        meta: {
          title: '报表管理',
          icon: 'setting',
          permission: ['Intelligent-water-plant-report'],
          appCode: 'Intelligent-water-plant'
        },
        redirect: '/Intelligent-water-plant/report-management/water-level',
        children: [
          {
            path: '/Intelligent-water-plant/report-management/water-enter',
            name: 'reportEnter',
            component: () => import('@/views/Intelligent-water-plant/report-management/water-enter'),
            meta: { title: '进厂水报表', icon: 'tool', keepAlive: true, permission: ['report-water-enter'] }
          },
          {
            path: '/Intelligent-water-plant/report-management/water-out',
            name: 'reportOut',
            component: () => import('@/views/Intelligent-water-plant/report-management/water-out'),
            meta: { title: '出厂水报表', icon: 'tool', keepAlive: true, permission: ['report-water-out'] }
          },
          {
            path: '/Intelligent-water-plant/report-management/water-level',
            name: 'reportLevel',
            component: () => import('@/views/Intelligent-water-plant/report-management/water-level'),
            meta: { title: '水位报表', icon: 'tool', keepAlive: true, permission: ['report-water-level'] }
          },
          {
            path: '/Intelligent-water-plant/report-management/water-quality',
            name: 'reportQuality',
            component: () => import('@/views/Intelligent-water-plant/report-management/water-quality'),
            meta: { title: '水质报表', icon: 'tool', keepAlive: true, permission: ['report-water-quality'] }
          }
        ]
      },
      {
        path: '/Intelligent-water-plant',
        name: 'IntelligentWaterPlant',
        component: RouteView,
        meta: {
          title: '报警管理',
          icon: 'setting',
          permission: ['Intelligent-water-plant'],
          appCode: 'Intelligent-water-plant'
        },
        redirect: '/Intelligent-water-plant/error-alarm',
        children: [
          {
            path: '/Intelligent-water-plant/error-alarm/CallThePolice',
            name: 'CallThePolice',
            component: () => import('@/views/Intelligent-water-plant/error-alarm/call-the-police'),
            meta: { title: '报警列表', icon: 'tool', keepAlive: true, permission: ['call-the-police'] }
          },
          // {
          //   path: '/Intelligent-water-plant/error-alarm/malfunction',
          //   name: 'malfunction',
          //   component: () => import('@/views/Intelligent-water-plant/error-alarm/malfunction'),
          //   meta: { title: '故障', icon: 'tool', keepAlive: true, permission: ['malfunction'] }
          // },
          {
            path: '/Intelligent-water-plant/Device-parameters',
            name: 'Pressurizing',
            component: () => import('@/views/Intelligent-water-plant/Device-parameters/Pressurizing-device'),
            meta: { title: '报警设置', icon: 'tool', keepAlive: true, permission: ['Pressurizing-device'] }
          }
          // {
          //   path: '/Device-parameters/dosing-plant',
          //   name: 'DosingPlant',
          //   component: () => import('@/views/Intelligent-water-plant/Device-parameters/dosing-plant'),
          //   meta: { title: '加药装置', icon: 'tool', keepAlive: true, permission: ['dosing-plant'] }
          // },
        ]
      },
      // // 营收系统
      // {
      //   path: '/revenue',
      //   name: 'Revenue',
      //   component: RouteView,
      //   redirect: '/revenue/system',
      //   meta: { title: '营收系统', keepAlive: false, permission: ['revenue_home'] },
      //   children: [
      //     {
      //       path: '/revenue/system',
      //       name: 'RevenueSystem',
      //       component: () => import('@/views/revenue/Revenue'),
      //       meta: { title: '用户管理', icon: 'tool', keepAlive: true, permission: ['revenue_usermanage'] }
      //     }
      //   ]
      // },
      {
        path: '/factory-historical-data',
        name: 'FactoryHistoricalData',
        component: RouteView,
        meta: {
          title: '历史数据',
          icon: 'tool',
          permission: ['factory-historical-data'],
          appCode: 'Intelligent-water-plant'
        },
        redirect: '/factory-historical-data/factory-equipment-history',
        children: [
          {
            path: '/factory-historical-data/factory-equipment-history',
            name: 'FactoryEquipmentHistory',
            component: () =>
              import('@/views/Intelligent-water-plant/factory-historical-data/factory-equipment-history'),
            meta: { title: '设备历史', icon: 'tool', keepAlive: true, permission: ['factory-equipment-history'] }
          },
          {
            path: '/factory-historical-data/factory-alarm-history',
            name: 'FactoryAlarmHistory',
            component: () => import('@/views/Intelligent-water-plant/factory-historical-data/factory-alarm-history'),
            meta: { title: '报警历史', icon: 'tool', keepAlive: true, permission: ['factory-alarm-history'] }
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: BlankLayout,
    meta: { title: 'menu.home', appCode: 'maps' },
    children: [
      {
        path: '/home/page',
        name: 'HomePage',
        component: () => import('@/views/home/page'),
        meta: { title: '首页', keepAlive: true }
      },
      {
        path: '/new-one-map',
        component: () => import('@/views/sys/NewOneMap'),
        meta: { title: 'GIS管网全览图', keepAlive: false, permission: ['one-map'] }
      },
      {
        path: '/water-new-one-map',
        component: () => import('@/views/sys/WaterNewOneMap'),
        meta: { title: '区域停水管控全览图', keepAlive: false, permission: ['water-new-one-map'] }
      },
      {
        path: '/MobileMap',
        component: () => import('@/views/sys/components/MobileMap'),
        meta: { title: '移动端区域停水', keepAlive: false, permission: ['water-new-one-map'] }
      },
      {
        path: '/partition-one-map',
        component: () => import('@/views/sys/PartitionOneMap'),
        meta: { title: '分区计量全览图', keepAlive: false, permission: ['partition-one-map'] }
      },
      {
        path: '/workbench',
        name: 'workbench',
        component: () => import('@/views/home/page'),
        meta: { title: '工作台', keepAlive: false, permission: ['home-page'] }
      },
      {
        path: '/DataVisualization',
        name: 'DataVisualization',
        component: () => import('@/views/DataVisualization/DataVisualization'),
        meta: { title: '数据可视化大屏', keepAlive: false, permission: ['data-visualization'] }
      },
      {
        path: '/WaterWorksVisualization',
        name: 'WaterWorksVisualization',
        component: () => import('@/views/WaterWorksVisualization/WaterWorksVisualization'),
        meta: { title: '水厂智能化大屏', keepAlive: false, permission: ['waterworks-visualization'] }
      },
      {
        path: '/WaterSourceMonitoring',
        name: 'WaterSourceMonitoring',
        component: () => import('@/views/WaterSourceMonitoring/WaterSourceMonitoring'),
        meta: { title: '水源监测大屏', keepAlive: false, permission: ['WaterSource-monitoring'] }
      },
      {
        path: '/Early-warning-alarm-large-screen',
        name: 'EarlyWarningAlarmLargeScreen',
        component: () => import('@/views/EarlyWarningAlarmLargeScreen/Early-warning-alarm-large-screen'),
        meta: { title: '预警报警大屏', keepAlive: false, permission: ['warning-alarm'] }
      },
      {
        path: '/big-user-home',
        component: () => import('@/views/bigusers/largeScreen/Home.vue'),
        meta: { title: '大用户管理大屏', keepAlive: false, permission: ['big-user-screen'] }
      },
      {
        path: '/water-works-home',
        component: () => import('@/views/waterWorks/homepage/WaterPlantLargeScreen.vue'),
        meta: { title: '智慧水厂大屏', keepAlive: false, permission: ['water-works-wisdom'] }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404Redirect')
  }
]
